module.exports = __webpack_public_path__ + "static/media/mira_mvp_header.f3648510.jpeg";